<template>
  <a-config-provider :locale="zhCN">
    <router-view></router-view>
  </a-config-provider>
  <!-- <Main/> -->
</template>

<script>
// import Main from './views/index.vue'
import zhCN from 'ant-design-vue/es/locale/zh_CN'
import dayjs from 'dayjs'
import dayjsZhCN from 'dayjs/locale/zh-cn'
dayjs.locale(dayjsZhCN)
export default {
  name: 'App',
  components: {
    // Main
  },
  data() {
    return {
      zhCN
    }
  }
}
</script>

<style lang="scss">

$complete: rgb(0, 158, 47);
$failure: rgb(201, 45, 17);
$info: rgb(0, 108, 158);

$await: rgb(139, 139, 139);

.complete{
  //完成， 成功
  color: $complete;
}
.failure{
  //失败， 错误
  color: $failure;
}
.info{
  //信息， 正常
  color: $info;
}
.await{
  //等待
  color: $await;
}

.my-scroll::-webkit-scrollbar {
  /*滚动条整体样式*/
  width: 4px; /*高宽分别对应横竖滚动条的尺寸*/
  height: 1px;
}
.my-scroll::-webkit-scrollbar-thumb {
  /*滚动条里面小方块*/
  border-radius: 10px;
  box-shadow: inset 0 0 5px rgba(97, 184, 179, 0.1);
  background: #a0d2fc;
}
.my-scroll::-webkit-scrollbar-track {
  /*滚动条里面轨道*/
  box-shadow: inset 0 0 5px rgba(87, 175, 187, 0.1);
  border-radius: 10px;
  background: #2c7085;
}
.index{
  /* 一级页面公共样式 */
  width: 100%;
  height: calc(100% - 10px);
  padding: 10px;
  background-image: linear-gradient( #FFFFFF, #ffffff);
  // border-radius: 10px;
  margin-top: 10px;
  // box-shadow:
  //       0 0.3px 0.6px rgba(1, 82, 158, 0.056),
  //       0 0.7px 1.3px rgba(1, 82, 158, 0.081),
  //       0 1.3px 2.5px rgba(1, 82, 158, 0.1),
  //       0 2.2px 4.5px rgba(1, 82, 158, 0.119),
  //       0 4.2px 8.4px rgba(1, 82, 158, 0.144),
  //       0 10px 20px rgba(1, 82, 158, 0.2);
}
// background-image: url('~@/assets/bg/2.svg');
// background-repeat: no-repeat;
// background-size: contain;//背景图全显示
// background-position: right;//靠右显示
// background-blend-mode: color;//颜色模式，跟随背景颜色变淡（这里是透明）
</style>
